module.exports = "dist/assinatura_eletronica.png?3e36eb6b34f49d28dd0a976057a25be6";